import Vue from 'vue';
import Router from 'vue-router';

import bannerList from '@/views/bannerList.vue';
import noticePage from '@/views/noticePage.vue';
import newsPage from '@/views/newsPage.vue';
import usersPage from '@/views/usersPage.vue';
import repairPage from '@/views/repairPage.vue';
import servicePage from '@/views/servicePage.vue';
import complaintsPage from '@/views/complaintsPage.vue';
import sharePage from '@/views/sharePage.vue';

Vue.use(Router);
const router = new Router({
	routes: [{
			path: '/',
			name: 'bannerList',
			component: bannerList,
			meta: {
				title: 'FOSS报修管理系统',
				requiresAuth: true
			}
		},
		{
			path: '/notice-page',
			name: 'noticePage',
			component: noticePage,
			meta: {
				title: 'FOSS报修管理系统',
				requiresAuth: true
			}
		},
		{
			path: '/news-page',
			name: 'newsPage',
			component: newsPage,
			meta: {
				title: 'FOSS报修管理系统',
				requiresAuth: true
			}
		},
		{
			path: '/users-page',
			name: 'usersPage',
			component: usersPage,
			meta: {
				title: 'FOSS报修管理系统',
				requiresAuth: true
			}
		},
		{
			path: '/repair-page',
			name: 'repairPage',
			component: repairPage,
			meta: {
				title: 'FOSS报修管理系统',
				requiresAuth: true
			}
		},
		{
			path: '/service-page',
			name: 'servicePage',
			component: servicePage,
			meta: {
				title: 'FOSS报修管理系统',
				requiresAuth: true
			}
		},
		{
			path: '/complaints-page',
			name: 'complaintsPage',
			component: complaintsPage,
			meta: {
				title: 'FOSS报修管理系统',
				requiresAuth: true
			}
		},
		{
			path: '/share-page',
			name: 'sharePage',
			component: sharePage,
			meta: {
				title: 'FOSS报修管理系统',
				requiresAuth: false,
				noLayout: true
			},
		}
	],

});

router.beforeEach((to, from, next) => {
	// 设置页面标题
	document.title = to.meta.title || 'FOSS报修管理系统';

	// 不需要认证的页面直接放行
	if (!to.meta.requiresAuth) {
		return next();
	}

	// 获取存储的认证信息
	const isLoggedIn = router.app.$store.state.isLoggedIn;

	if (!isLoggedIn) {
		// 未登录，跳转到登录状态
		return next({
			path: '/', // 由于你的登录页不是路由，我们回到根路径
			query: {
				redirect: to.fullPath,
				requireAuth: true
			}
		});
	}

	const userInfo = JSON.parse(localStorage.getItem('token') || '{}');
	const userRole = userInfo.role;

	if (userRole == 2 && to.path === '/') {
		return next('/repair-page');
	}

	// 其他情况放行
	next();
});

export default router;